import "core-js/modules/es.function.name.js";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { backwardsCompatibleValues, useStrictLocalization } from "@faire/web/common/localization";
import { useActionTypes } from "../hooks/useActionTypes";
import { useShowMessage } from "../hooks/useShowMessage";
import { QuickActionType } from "../types";
export var ButtonText = function ButtonText(_ref) {
  var selectedOption = _ref.selectedOption,
    dropdownOptions = _ref.dropdownOptions,
    modalContent = _ref.modalContent;
  var _useActionTypes = useActionTypes(),
    actionType = _useActionTypes.actionType;
  var _useShowMessage = useShowMessage(dropdownOptions, selectedOption),
    showEmptyState = _useShowMessage.showEmptyState;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  if (selectedOption && (actionType === null || actionType === void 0 ? void 0 : actionType.id) === QuickActionType.CONTACT_A_BRAND) {
    return strictLocalize({
      id: "7T323G",
      defaultMessage: [{
        "type": 0,
        "value": "Contacter "
      }, {
        "type": 1,
        "value": "brandName"
      }]
    }, backwardsCompatibleValues({
      brandName: selectedOption.name
    }));
  }
  if (showEmptyState) {
    return isRetailer() ? strictLocalize({
      id: "tCfvaF",
      defaultMessage: [{
        "type": 0,
        "value": "Retour aux guides des commerçants"
      }]
    }) : strictLocalize({
      id: "cd8Dfz",
      defaultMessage: [{
        "type": 0,
        "value": "Retour aux guides de marques"
      }]
    });
  }
  return modalContent === null || modalContent === void 0 ? void 0 : modalContent.buttonText;
};